import api from "../../services/api";

const path = "v1/contrato";

export const getContract = async ({ pageNumber, filterByText, status }) => {
  return await api.get(
    `${path}/${
      pageNumber !== (null || NaN) ? `?pageNumber=${pageNumber}` : ""
    }${filterByText ? `&filterByText=${filterByText}` : ""}${
      status ? `&status=${status}` : ""
    }
    `
  );
};

export const getDetailContract = async ({ id }) => {
  return await api.get(`${path}/${id}/detalhamento`);
};

export const postMapItemContract = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const putItemContract = async ({ body }) => {
  return await api.put(`${path}`, body);
};
